import kebabCase from 'lodash/kebabCase';

function transformConstants<T extends string>(constants: T[]): Record<T, string> {
  return constants.reduce(
    (sum, constant) => {
      return {
        ...sum,
        [constant]: kebabCase(constant),
      };
    },
    {} as Record<T, string>,
  );
}

export { transformConstants };
